<div [class]="'w-screen z-40 flex justify-between py-4 px-5 md:px-16 h-24 top-0 '+(sticky?'fixed':'')">
    <div [class]="'transition-all '+(direction?'':'scale-75')">
        <logo></logo>

    </div>
<div (click)="openMenu()" [class]="'cursor-pointer h-[min-content]  hover:text-indigo-400'"><em [class]="'transition-all text-xl xl:text-5xl pi pi-bars active:scale-50 p-5 '+ (direction?'':'scale-75')"></em></div>
</div>
